export const DosageKind = Object.freeze({
  DURATION: "Duration", // Triggered by Time (mostly Go)
  REPETITION: "Repetition", //Triggered by Repetition (mostly Pro)
  LOGIC: "Logic", // Triggered by Game Logic (example : Mind4, Stardust)
});
